<template>
  <div>
    <div class="header" ref="header">
      <!-- <van-field v-model="word" left-icon="search" placeholder="搜索关键字" class="searchInput"/>
      <span>搜索</span>-->
      <van-search
        v-model="keyWord"
        shape="round"
        placeholder="搜索关键字"
        show-action
        style="width:9.15rem;"
        :disabled="!cityId&&!areaId"
        @cancel="cancel"
      >
        <template #action>
          <div @click="onSearch" class="searchBtn">搜索</div>
        </template>
      </van-search>
    </div>
    <div class="content">
      <div class="province" ref="province">
        <li
          v-for="(item,index) in provinceList"
          :key="index"
          :class="[provinceIndex===index?'active':'']"
          @click="choose('province',item,index)"
        >{{item.areaName}}</li>
      </div>
      <div class="city" ref="city">
        <li
          v-for="(item,index) in cityList"
          :key="index"
          :class="[cityIndex===index?'activeCity':'']"
          @click="choose('city',item,index)"
        >{{item.areaName}}</li>
      </div>
      <div class="city" ref="area">
        <li
          v-for="(item,index) in areaList"
          :key="index"
          :class="[areaIndex===index?'activeCity':'']"
          @click="choose('area',item,index)"
        >{{item.areaName}}</li>
      </div>
    </div>
    <van-popup v-model="show" position="bottom" :style="{ height: '12.8rem' }" class="showPop">
      <div class="popHeader">
        <span>请选择医院</span>
        <van-icon name="cross" style="font-size:.5rem;" @click="close" />
      </div>
      <ul class="popUl" v-if="hospitalList.length>0">
        <li
          v-for="(item,index) in hospitalList"
          :key="index"
          @click="chooseHospital(item)"
        >{{item.fullName}}</li>
      </ul>
      <div v-else>暂无匹配的医院~</div>
    </van-popup>
  </div>
</template>
<script>
import { dicBase } from "@/api/ajax"
import { mapMutations, mapActions, mapState } from 'vuex';
export default {
  data () {
    return {
      keyWord: '',
      provinceIndex: '',
      areaIndex: '',
      provinceList: [],
      cityList: [],
      areaList: [],
      cityIndex: '',
      cityId: '',
      hospitalList: [],
      areaId: '',
      show: false,
    }
  },
  props:{
    isComponent: Boolean
  },
  methods: {
    ...mapMutations(['SAVE_HOS', 'SET_PERFECT']),
    cancel(){
      if(this.isComponent){
        this.$emit('cancel');
        return;
      }
    },
    chooseHospital (item) {
      this.SAVE_HOS(item)
      // 通过query传参，判断是否回退页面
      if(this.isComponent){
        this.$emit('change', item);
        return;
      }
      if(this.$route.query.back){
        this.$router.go(-1);
      }else{
        this.$router.push({
          name: 'perfect'
        })
      }
    },
    onSearch () {
      let { cityId, areaId, keyWord } = this
      dicBase.cityAreaHospitalList({
        cityId,
        areaId,
        keyWord
      }).then(res => {
        this.hospitalList = res.data.data
        this.show = true
      })
    },
    choose (type, item, index) {
      if (type === 'province') {
        this.provinceIndex = index
        this.getCityList(item.id)
      } else if (type === 'city') {
        this.cityIndex = index
        this.cityId = item.id
        this.getAreaList(item.id)
      } else if (type === 'area') {
        this.areaIndex = index
        this.areaId = item.id
        dicBase.areaHospitalList({
          areaId: this.areaId
        }).then(res => {
          this.hospitalList = res.data.data
          this.show = true
        })
      }
    },
    getCityList (id) {
      this.cityIndex = ''
      this.areaIndex = ''
      this.areaList = []
      dicBase.cityAreList({
        parentId: id
      }).then(res => {
        this.cityList = res.data.data

      })
    },
    getAreaList (id) {
      this.areaIndex = ''
      dicBase.cityAreList({
        parentId: id
      }).then(res => {
        this.areaList = res.data.data
      })
    },
    close () {
      this.show = false
    }
  },
  created () {
    dicBase.provinceList().then(res => {
      this.provinceList = res.data.data
    })
    this.$nextTick(() => {
      let h = window.screen.height
      let headerH = this.$refs.header.offsetHeight
      this.$refs.province.style.height = (h - headerH - 4) + 'px'
      this.$refs.city.style.height = (h - headerH - 4) + 'px'
      this.$refs.area.style.height = (h - headerH - 4) + 'px'
    })
  }

}
</script>
<style lang='less' scoped>
.showPop {
  border-radius: 0.21rem 0.21rem 0rem 0rem;
  .popHeader {
    padding: 0.53rem 0.43rem;
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid #f0f0f2;
    span {
      font-size: 0.48rem;
      font-weight: bold;
      color: rgba(20, 20, 19, 1);
      line-height: 0.48rem;
    }
  }
  .popUl {
    padding: 0.53rem 0.43rem;
    li {
      color: #141413;
      line-height: 1.07rem;
      font-size: 0.43rem;
      line-height: 1;
      margin-bottom: 0.85rem;
    }
  }
}
.header {
  .searchBtn {
    font-size: 0.43rem;
    font-weight: 500;
    color: rgba(20, 20, 19, 1);
    line-height: 0.43rem;
  }
  .searchInput {
    width: 7.87rem;
    height: 0.85rem;
    padding: 0.21rem 0.32rem;
    border-radius: 0.42rem;
    background: #f4f4f6;
    display: flex;
    align-items: center;
  }
}
.active {
  background: #3667ec;
  color: #fff !important;
}
.activeCity {
  background: #3667ec;
  color: #fff !important;
  border-radius: 0.11rem;
}
.content {
  background: #f4f4f6;
  padding-top: 0.1rem;
  display: flex;
  .province {
    background: #fff;
    width: 2.45rem;
    overflow: scroll;
    li {
      height: 1.07rem;
      line-height: 1.07rem;
      font-size: 0.43rem;
      color: #141413;
      text-align: center;
      margin-bottom: 0.21rem;
    }
  }
  .province::-webkit-scrollbar {
    display: none; /* Chrome Safari */
  }
  .city::-webkit-scrollbar {
    display: none; /* Chrome Safari */
  }
  .city {
    margin-left: 0.44rem;
    overflow: scroll;
    padding-top: 0.37rem;
    flex: 1;
    // margin-right: 0.44rem;
    li {
      padding: 0.21rem;
      font-size: 0.43rem;
      color: #141413;
      text-align: center;
      margin-bottom: 0.21rem;
    }
  }
}
</style>